import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const Dimension3DIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.35 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* 3D dimension axes: vertical, horizontal, diagonal */}
      <path
        d="M5 18V6M5 18H16.5M16.5 18L20.5 14"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />

      {/* Dimension-style end ticks */}
      <path
        d="M3.8 6H6.2M3.8 18H6.2M16.5 16.8V19.2M19.65 13.15L21.35 14.85"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        opacity={0.6}
      />

      {/* Arrowheads */}
      <path
        d="M5 6L4 7.15M5 6L6 7.15M16.5 18L15.25 16.9M16.5 18L15.25 19.1M20.5 14L19.05 14.25M20.5 14L20.25 15.45"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </BaseIcon>
  ),
);

Dimension3DIcon.displayName = 'Dimension3DIcon';
